import { IconProps } from 'icons/Credits.icon';
import React from 'react';

const PlusGreenIcon: React.FC<IconProps> = ({ color = '#ffffff' }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="3.2" fill="#31C07D" />
      <path
        d="M10.3999 16H21.5999"
        stroke={color}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 10.4V21.6"
        stroke={color}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default PlusGreenIcon;
